module.exports = __webpack_public_path__ + "static/media/icon-estoque-rel-posicao.14e30a5c.png";